module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headings":{"application":"Application"},"actions":{"logout":"Log out"}},"fi":{"headings":{"application":"Sovellus"},"actions":{"logout":"Kirjaudu ulos"}}}')
  delete Component.options._Ctor
}
